module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/todo_en-8122b67df1e36e29e670287774e58aa2.png";